import { isInt } from 'validator';

export const isTerminal = (terminalId) =>
  terminalId && terminalId.length && isInt(terminalId.toString());

export const netsCloudDefault = {
  username: '',
  password: '',
  terminal: '',
};

export const netsCloudFields = {
  account: {
    username: {
      id: 'username',
      title: 'Username',
      type: 'text',
      validate: (val) => (val?.length ? null : 'Username is required.'),
    },
    password: {
      id: 'password',
      title: 'Password',
      type: 'password',
      validate: (val) => (val?.length ? null : 'Password is required.'),
    },
  },
  pos: {
    terminal: {
      id: 'terminal',
      title: 'Terminal ID',
      type: 'select',
      options: [{ name: 'Select Terminal', value: '' }],
      validate: (val) => {
        if (val?.length) {
          return isTerminal(val) ? null : 'Terminal ID is invalid';
        }
        return 'Terminal ID is required';
      },
    },
  },
};
